import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { ContentUpgrades } from "@swizec/gatsby-theme-course-platform";
export const _frontmatter = {
  "title": "That time serverless melted my credit card",
  "description": "Serverless is pretty cheap. But you *can* get it wrong.",
  "published": "2021-03-12T00:00:00.000Z",
  "hero": "./img/screenshot-1615570161152.png",
  "categories": "Serverless, Technical",
  "content_upgrade": "ServerlessHandbook"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Friend, we talked about how cheap serverless can be. But you `}<em parentName="p">{`can`}</em>{` get it wrong 😅`}</p>
    <p>{`A fun story from ye olden days of 2010:`}</p>
    <p>{`Act 1 of the hero's journey. Young kid with big dreams chases his idea with all the piss and vinegar he can muster, gathers a motley crew, and conquers the world. At the moment of triumph, the hero trips and breaks his nose.`}</p>
    <p>{`Crowd laughs.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/a715c39fec645f1b07c68c9cb3a97b27/e1596/Young-Swiz-at-his-best5e251g.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75.33632286995517%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'301\\'%20viewBox=\\'0%200%20400%20301\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20150v151h20l17-1-3-1c0-2%206%200%207%201s8-3%209-6c1-2-6-8-9-8h-2l1-1%203-2h3c2%200%202%200%201-2l1-1%202-1%203-2h1v-4c1-1%202-2%201-3l5-2%2012-5%204-1%204-2%207-1%2012-3v-4l1%202%201%202h5c1-1%201-1%201%201%200%201%201%201%204-2l3-2c0%201%201%202%202%201%202%200%202%200%202%202-1%202%200%202%202%202l2-1v11l1%2013-3%203-2%202c0%201-12%2013-14%2013l-1%201c-1%201%201%201%204%201%204%200%205%200%204-1v-3c2-3%2012-12%2014-12l1-2%202-6%203-9c0-3%200-4%201-3%202%203%209%208%2012%208s3%200%203-3l-1-4h5l4%201%205%201a161%20161%200%200115%202c-3-1-2-2%202-2%203%200%204%200%203%201l2%201%203-1v-1l1-2%202%202h3c4-2%208-1%2011%202l4%203c1%200%202%201%200%207l-2%2014v7h41v-7l1-8v-2l-1-2c1%200%2014%2010%2017%2014h1l6%202c7%204%2027%204%2028%201%201-4%2017-4%2019%200%201%202%201%202%2027%202h25l9-4c11-6%209-6%2013-2l7%204%204%201V0h-48v6l-7%2043v4h6a2009%202009%200%200044-5h4v45h-11l-12%201%2011%201h12c0%202-40%204-41%202h-6c-3-2-2-3%201-3h1l-1-1c0-2-2-3-3-2l-1%203-1%202v-1l-1-1c-1%200-2%200-1%201l-1%201-1-1-4-1c-3%200-4%200-3%201l-1%201-1%203c0%203%200%203%201%202h5c0-2%2018-1%2018%200h3c3-1%2023-1%2033%201l5%201h-5c-3%200-4%200-3%201h7v52h-4c-4%201-5%202-6%206-1%202-1%202%201%202l5-2h4v53l-4-1c-5%200-13-4-13-5l4-1c3-1%203-1%201-3l-6-2c-6-1-8-2-8-4l-1-2c-2%200-1%204%205%2013a250%20250%200%200120%2037c2%204%202%204%200%206-2%203-8%206-15%207-7%202-9%201-9-4a854%20854%200%2000-12-39l-8-7c-10-8-12-9-22-7-11%202-17%202-18%200l-1-2%203-6c3-9%203-11%202-11l-1-2%203-1h1c0-1-4-4-8-4-4-1-4-1-4%202l-1%205-1%207c-1%208-2%209-8%206-4-3-7-5-4-5%200%200%203-6%205-16%201-2-1-3-15-6a485%20485%200%2001-42-10c-3-1-3-1-5-15l1-7v-2l-1-3c0-4-7-11-12-12-8-2-17-1-18%204-2%202-3%202-6%201-3-2-8-1-11%201-2%203-3%202-3-1l-2%2016c0%203-1%204-2%204l-2%204c-1%204-3%204-2%200%200-4%200-4-6-6l-9-5c-5-1-5-1-2-13l1-9c0-3-1-1-2%203-2%2010-2%2011-7%2011l-7%202-4%201%202-35h9l9-1v6l-1%206%202-6%201-6%208-1h9c1-1%202-2%202-5%200-4-1-5-2-4l-1-1h-6l-4%202c-4%200-4%200-5-4l3-36V36c0-12%200-16%202-23l1-9V1h40l-86-1H0v150m0%201a2463%202463%200%20002%2056v-3l1-1H2l-1-10c0-10%200-12%202-8%201%203%201%203%207%202%207-1%206-1%206-5L6%20171H1V86a3966%203966%200%2000-1%2065M93%203v2l-1%201v6c0%206%200%207-2%208l-1%201%204%203%204%202-4-1-6-2h-2l3%203c2%202%202%202%201%204-2%204%201%207%2012%209l7%202c0%201%205%203%2012%204%206%201%207%201%206%203%200%204-2%2039-1%2040l2-1c3-1%2014-4%2015-3l1-1%202-2%201-2-1-2c-2%200-2-1-2-6v-7h3c6%200%207%201%206%207%200%205%200%206-2%206s-3%201-2%203l3%201c2-1%202-1%201%205l1%205%202-5%201-26c1-7%201-7%205-6%205%202%207%201%207-1l-1-2v-1l2-6c1-5-1-17-2-16-1%200-1%204%201%208l-1%202c-5%200-7%2010-3%2010l-1%201c-3%202-7%200-7-4l2-10%201-8v-2c-1-1-2%200-2%204-1%204-1%205-2%204s-1-1-1%201c0%201%200%202-1%201v-1l-1-1-1%201v1l1%201-4%201c-2%200-3%200-3%202l-1%202v-1c1-2%200-3-2-1-1%201-1%201-1-1l1-2c2%200%202-1%203-3%200-2%203-5%206-6l2-2c-1-2%202-3%206-2%202%200%203%200%204-3s4-3%202%200l1%202%201%202c1%201%201%201%201-1l2-9%202-10V1h-39C97%201%2094%201%2093%203m9%2017l-2%202c0%202-4%206-6%206-3%201-4%204-1%206l8%202%209%202h4c2-2%206-1%206%200a574%20574%200%20015%203c2%201%202%201%202-2s6-10%208-10l1-1c0-2-1-1-4%201l-4%201h-2v-4l-2%201-2%202-2%201-2%202c-2%201-2%201-2-1l-2-2-1%202c-1%202%200%202%201%202%202%200%202%200%201%202h-3l-2-1c-4%200-8-7-6-12%201-3%201-3-2-2m-58%207l6%204v1c-2%201-2%201%202%201l4%201-4%201-4-1h-2c-4%201-11%201-12-1s-2-1-2%202c0%202%200%203%202%202l3%201%203%202c1%201%200%201-1%201-4%200%2012%204%2017%204%203%200%204%200%203-1s3-10%204-10%205-4%205-6l-22-4h-5l3%203m62%2017l-2%203-3%201-3%202c-3%202-2%202%207%204l12%202h3v-4c0-5%200-5-4-6l-6-1-3-1h-1m-8%2015c-2%209-2%2029-1%2027%202-2%204-1%204%202-1%202%200%202%202%202h4c2-1%203-11%203-22v-8l-3%201-2-1c1-2%200-2-2-3-4-2-5-1-5%202M72%2073l-6%204-5%202c-4%200-9%202-9%204l6%201c11%202%2011%202%2010%206%200%202-1%203-2%203l-12-1c-11-1-11-1-11-4l-1-3-1%202c0%202%200%202-1%201h-5l2%201c1-1%202%200%203%201v2l-1%201h2l1%201-2%201v1l1%201-1%201v1c0%202%205%205%206%204l1%201c1%202-2%203-2%201h-1c0%202%202%203%204%203l6%203h2l1-1c2%202%2016-8%2015-10v-3c3-5%205-26%203-26l-3%202m68%2035l-3%2019c-3%2023-3%2022%204%2022a9513%209513%200%200131%201c3-2%202-3%200-3l-2%201c1%202-6%202-23%200l-11-1%202-13a580%20580%200%20012-26m73%2028c-4%202-5%204-3%204%203%200%203%202%201%204-2%203-1%205%204%205%203%200%203%200%201%201s-2%204%200%207v2c0%201%200%202%202%201%203-1%205-3%206-8v-5h-3l-2%201%202-2c3-2%203-8-1-9h-3l-1-1h-3M55%20160c-2%202-2%203%200%206%202%204%200%209-4%2011-2%201-3%204%200%204%201%200%202%203%200%203-1%201%203%206%204%206%202%200%203-4%202-5-2%200-3-5-2-6s2-3%202-8v-7l3%201%203-1c1-1%200-1-1-1l-2-1c1%200%200-2-2-3l-2-2-1%203m65%201c-1%202-3%202-10%202l-12%201h-4l-1%201c1%202-1%203-6%203-4%200-4%200-4%203%201%202%200%202-1%203-3%200-1%202%201%201%202%200%202%200%201%201v2l2%203c0%202%203%206%205%206%201%201%201%201-1%202l-3%203v4c-1%201%200%201%201%201%204%200%207%200%207-2%202-2%202-6%201-6s-2-5%200-7l1-3%201-2%201%202c0%202%200%203%205%203l7-1%203-1h10l1-2c1%201%202-5%202-10v-5c2-1%201-2-2-2h-5m-57%206h-4v7c0%208%201%209%206%206%203-2%208-1%207%202v5c0%202%200%203%203%203l5-1v-12h-1l-1%201-1-1-1-1c-2-1-2-1-1%201%200%203-3%202-7-1l-3-2v-1l1-1h4l-1-3-1-2-1-1-4%201m124%2014c-1%204%2016%208%2018%204l2-1h1c0-2%200-3-2-3l-2-1-9-1c-7%200-8%201-8%202m49%206c-3%201-5%203-3%205%203%204-3%205-21%204-14%200-14%200-19%203-4%202-9%209-5%208h2c1%201%202%201%204-1%205-3%206-3%203%201-3%203-2%203%203%200%207-4%2011-4%2019-2h14c9-1%209-1%206%204l-4%206c-2%206-5%208-11%208-7%201-12%204-11%208%201%202%201%202-3%202h-2l-2%201-4-2c-1-5-8-6-7-1%201%201%200%203-2%205-3%203-4%206-2%208%201%201%202%203%201%206%200%205%200%205%204%208l6%204c7%208%207%208%209-1%203-10%203-18%200-18l-3-2%201-1%203%202%203-3c2-4%205-6%207-6l4-1c3-1%2012%200%2023%203l11%204%204-15%201-8c0-2%200-2-8-2h-9l2-2c2%200%202%200%200-1s-1-1%203-1%205%200%203%201-2%201%201%201l6-2c3-1%203-2%203-9l1-3%201-2c0-2-8-3-10-1h-2c-2%200-3%200-3%202-1%202-5%205-5%203l-2%201c-3%203-3%203-2-5%201-10%200-11-8-9m-169%205c-6%200-7%201-7%203l1%206%201%205%201%202c-3%202%205%204%208%202v-1c-1%200-1-1%201-2%202-2%205-11%205-13-1-2-6-3-10-2m42%204l-2%201-3%201h-4c-2%200-3%200-3%202-1%204%204%206%2012%203h6l-1%201c-6%200-7%201-5%202s7%200%207-1l2-1%202-3c0-2%200-2-1-1l-2%202v-1c1-1%202-4%201-6-2-2-9-1-9%201m48%2015l3%203%202%202-2%202-2%202%202%202c3%203%200%203-4%200-5-3-7%200-2%205%204%204%2012%205%208%200-1-1-1-1%201-1%203%201%204%200%203-1l-1-4c-1-3-1-3-1-1-1%201-2%202-3%201-1%200-1-1%201-4%203-3%203-5%200-3l-1-1-2-2h-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a715c39fec645f1b07c68c9cb3a97b27/ca0a1/Young-Swiz-at-his-best5e251g.webp 223w", "/static/a715c39fec645f1b07c68c9cb3a97b27/75680/Young-Swiz-at-his-best5e251g.webp 445w", "/static/a715c39fec645f1b07c68c9cb3a97b27/8d1ba/Young-Swiz-at-his-best5e251g.webp 890w", "/static/a715c39fec645f1b07c68c9cb3a97b27/3838e/Young-Swiz-at-his-best5e251g.webp 1335w", "/static/a715c39fec645f1b07c68c9cb3a97b27/e11e5/Young-Swiz-at-his-best5e251g.webp 1780w", "/static/a715c39fec645f1b07c68c9cb3a97b27/8df42/Young-Swiz-at-his-best5e251g.webp 2048w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a715c39fec645f1b07c68c9cb3a97b27/853b2/Young-Swiz-at-his-best5e251g.jpg 223w", "/static/a715c39fec645f1b07c68c9cb3a97b27/0a4fe/Young-Swiz-at-his-best5e251g.jpg 445w", "/static/a715c39fec645f1b07c68c9cb3a97b27/7f80b/Young-Swiz-at-his-best5e251g.jpg 890w", "/static/a715c39fec645f1b07c68c9cb3a97b27/dc6ba/Young-Swiz-at-his-best5e251g.jpg 1335w", "/static/a715c39fec645f1b07c68c9cb3a97b27/2d2e5/Young-Swiz-at-his-best5e251g.jpg 1780w", "/static/a715c39fec645f1b07c68c9cb3a97b27/e1596/Young-Swiz-at-his-best5e251g.jpg 2048w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a715c39fec645f1b07c68c9cb3a97b27/7f80b/Young-Swiz-at-his-best5e251g.jpg",
                "alt": "Young Swiz at his best",
                "title": "Young Swiz at his best",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Young Swiz at his best`}</figcaption>{`
  `}</figure></p>
    <p>{`That's me pitching my first startup back in college. I'm not stoned, I just didn't sleep a lot those days. 😴`}</p>
    <p>{`Youth – when you can work until 3am, watch 2 episodes of True Blood before bed, and get up at 9am to do it all over again.`}</p>
    <p>{`Good times!`}</p>
    <h2 {...{
      "id": "a-grand-idea"
    }}>{`A grand idea`}</h2>
    <p>{`Like any big-to-be startup, ours started with a grand idea.`}</p>
    <p><em parentName="p">{`"There sure is lots of data on these newfangled social medias. Would be nice if it was easier to follow 🤔"`}</em></p>
    <p>{`Back then social media was the future. Everything in public, citizen journalism, changing the world! Transparency and empowerment for all! 💪`}</p>
    <p>{`Keeping up was a full-time job.`}</p>
    <p>{`What if you could observe a user's behavior – replies, favs, clicks, long pauses – feed that into an algorithm, and create a `}<em parentName="p">{`personalized feed`}</em>{`. Like a personal newspaper.`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media3.giphy.com/media/26BRBKqUiq586bRVm/giphy-loop.mp4?cid=7cf28b0fm7ddngptsy3rj9pluqzxsukugaivkvjrhdfv4f4e&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <ContentUpgrades.ServerlessHandbook />
    <h2 {...{
      "id": "but-tech-is-hard"
    }}>{`But tech is hard`}</h2>
    <p>{`I read lots of Wikipedia about machine learning and AI and got to work. Soon there was a prototype.`}</p>
    <p>{`No pictures survive but it was wonderful.`}</p>
    <p>{`A `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Reinforcement_learning"
      }}>{`reinforcement-learning`}</a>{` approach that interpreted user actions on the fly. You could `}<em parentName="p">{`see the code learn`}</em>{`. Point at your RSS feeds, read as normal, see your homepage change.`}</p>
    <p>{`😍`}</p>
    <p>{`Now how do you scale this?`}</p>
    <p>{`When it runs on the server in your bedroom it's a cool toy for you and your friends. A slow flaky toy.`}</p>
    <p>{`Can you make it internet scale? A popular buzzword back then. Everyone's the next Google! We need `}<em parentName="p">{`internet scale`}</em>{` right meow!!!`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media4.giphy.com/media/1WHAlOdc9ZNUZq85JI/giphy-loop.mp4?cid=7cf28b0fra3pcl6votoidrxgicl03cudtpvq6mh2plgjopls&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <h2 {...{
      "id": "2010-was-a-dash-early-for-serverless-"
    }}>{`2010 was a dash early for serverless 😬`}</h2>
    <p>{`Using Django, a neural net implemented in SQL, and running on a traditional server wasn't working. Scaled to about half a user.`}</p>
    <p>{`Lesson learned: Don't implement neural networks as foreign keys in a database. At least use a graph db ... those weren't well-known yet.`}</p>
    <p>{`We ate the hype and used internet scale serverless technologies. Called "managed cloud" or "platform as a service" back then. Depends who you ask ... it was new.`}</p>
    <p><a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Google_App_Engine"
      }}>{`Google App Engine`}</a>{` was all the rage and `}<em parentName="p">{`definitely`}</em>{` the future. `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Bigtable"
      }}>{`Bigtable`}</a>{` was the hot new database offering with infinite scale.`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media2.giphy.com/media/l4pT6owvWSmHzKUtW/giphy-loop.mp4?cid=7cf28b0fv1o2yxfdvsda4u7cwy1hs7gfhfsnyu35o8lco2u0&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <p>{`Getting it all to work was ... rough. So fricken complicated!`}</p>
    <p>{`When everything's asynchronous, you have `}<em parentName="p">{`zero`}</em>{` relational support, foreign keys are a joke, all your data are a slow search away, and you're 23 with no guidance or direction building big things for the first time ... yeah ...`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/1815b2d42cbee8dd7ec069b67d78abda/6f43f/How-I-remember-the-architecturegc92aj.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "62.78026905829597%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'250\\'%20viewBox=\\'0%200%20400%20250\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M267%2045c-4%201-7%203-7%205s-3%201-6-2c-4-2-8-2-15%201l-6%201c-8-3-11-2-12%201-2%204%200%205%205%204l6-3c2-2%205-1%205%201s1%202%203%202l12-2c0-1-4-1-11%201-3%200-3%200-2-2%201-4%2014-6%2013-2%200%202%201%202%203%202l4%201c0%203%202%203%208%201%206-1%207-2%206-6%200-3-2-4-6-3M102%2069l-1%209-2%2024c-2%2018-2%2023-1%2023l1-6%202-17%201-21c0-9%200-10%202-11l22-1c18%200%2019%200%2019%202l-2%209c0%204-1%2013-3%2019l-3%2019c0%208%201%208-20%208l-17%202h18c15-1%2019-1%2019%201%201%201%202%201%203-2v-2c-2%200-1-10%201-23%203-11%205-28%205-32%200-2-2-2-21-2l-23%201m2%2040l-1%203v4c-1%202%203%203%208%201%204-2%205-4%202-8h-9m117%2012l-6%202c-4%201-9%206-9%208l-1%208c-2%2012-1%2015%205%2018%205%203%2011%204%2015%202l2-2-3%201c-3%202-7%201-13-1-6-3-6-5-5-12l2-10v-3l10-1%2013-1%203-2v3c0%206-3%2015-5%2015h-16c-5-2-7-2-2%200%204%202%2013%202%2016%201s3-1%202%205v4l2-3%202-10%203-14c0-7%200-7-3-8h-12m3%201l-3%202-3%201c-4%200-9%202-9%204%200%204%2020%201%2024-3%203-3-2-6-9-4m110%2057l-7%201c-6%200-8%202-7%206%202%208%202%2020%201%2021-2%201%2011%207%2016%207s11-2%209-3l-3%201c-3%202-8%201-14-2l-6-2v-6c0-5%200-5%202-5%204%202%2012%203%2016%203l4-1-1%205%201%204%201-5c0-3%201-4%202-5v-1c-2%200-2-1-2-7l1-7-4-3c-4-2-7-3-9-1m-13%206l2%206c0%205%200%205%205%206l10%201h7v-11l-10-1-12-2c-2-1-2-1-2%201m-21%2016c-8%201-10%202-10%203h3l-20%2011-22%2012a357%20357%200%200154-25c3-1%204%200%202%202l-4%207%203-3%204-6c2-2%200-3-10-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1815b2d42cbee8dd7ec069b67d78abda/ca0a1/How-I-remember-the-architecturegc92aj.webp 223w", "/static/1815b2d42cbee8dd7ec069b67d78abda/75680/How-I-remember-the-architecturegc92aj.webp 445w", "/static/1815b2d42cbee8dd7ec069b67d78abda/8d1ba/How-I-remember-the-architecturegc92aj.webp 890w", "/static/1815b2d42cbee8dd7ec069b67d78abda/3838e/How-I-remember-the-architecturegc92aj.webp 1335w", "/static/1815b2d42cbee8dd7ec069b67d78abda/e11e5/How-I-remember-the-architecturegc92aj.webp 1780w", "/static/1815b2d42cbee8dd7ec069b67d78abda/a3c90/How-I-remember-the-architecturegc92aj.webp 2227w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1815b2d42cbee8dd7ec069b67d78abda/e92b6/How-I-remember-the-architecturegc92aj.png 223w", "/static/1815b2d42cbee8dd7ec069b67d78abda/e66bf/How-I-remember-the-architecturegc92aj.png 445w", "/static/1815b2d42cbee8dd7ec069b67d78abda/4ef49/How-I-remember-the-architecturegc92aj.png 890w", "/static/1815b2d42cbee8dd7ec069b67d78abda/4e814/How-I-remember-the-architecturegc92aj.png 1335w", "/static/1815b2d42cbee8dd7ec069b67d78abda/701e9/How-I-remember-the-architecturegc92aj.png 1780w", "/static/1815b2d42cbee8dd7ec069b67d78abda/6f43f/How-I-remember-the-architecturegc92aj.png 2227w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/1815b2d42cbee8dd7ec069b67d78abda/4ef49/How-I-remember-the-architecturegc92aj.png",
                "alt": "How I remember the architecture",
                "title": "How I remember the architecture",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`How I remember the architecture`}</figcaption>{`
  `}</figure></p>
    <p>{`But we got it working!`}</p>
    <p>{`Articles came in through a queue that checked your RSS. Each went into a parsing queue that called a traditional server running NodeJS to extract article text.`}</p>
    <p>{`App Engine didn't have NodeJS support and the library we needed was in JavaScript 🙃`}</p>
    <p>{`Those servers fed back into a queue that fed into a BigTable that fed into a queue that fed into tokenizers that fed keywords into another BigTable that held `}<inlineCode parentName="p">{`(user, keyword, weight)`}</inlineCode>{` vectors.`}</p>
    <p>{`You could take an article, look at its keywords, query vectors in the database, and assign a `}<em parentName="p">{`"How much will user like this?"`}</em>{` score.`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media3.giphy.com/media/26BRBKqUiq586bRVm/giphy-loop.mp4?cid=7cf28b0fm7ddngptsy3rj9pluqzxsukugaivkvjrhdfv4f4e&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <h2 {...{
      "id": ""
    }}>{`🔥`}</h2>
    <p>{`For 3 users, Google App Engine was free. Straining under the load of our very brilliant architecture and massive use of compute, but free.`}</p>
    <p>{`Then we released the iPad app. Back when if you built it they did come.`}</p>
    <p>{`10 downloads
20 downloads
100 downloads
500 downloads
1000 ...`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media0.giphy.com/media/RfAeAnzf7hUwm8PYej/giphy-loop.mp4?cid=7cf28b0frmwgtut4z72zu0csskwvypy4w9xtivhvdllwlngv&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <p>{`We were backed up for days. The queue filled up with thousands of articles. You clicked a button, we imported 500 feeds, 3000 articles, and died. Trying to build `}<em parentName="p">{`your`}</em>{` neural net.`}</p>
    <p>{`No deduping between users. No guarantee you'll come back. Just an endless grind of computing power doing nothing useful.`}</p>
    <p>{`The startup ran out of money and died before we ever finished that first batch of articles. 💸`}</p>
    <p>{`How about you, any fun lessons to share?`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`PS: a decade later serverless is much nicer, I promise :)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      